import { type AlbumCollectionTypeEnumEnum } from '@/shared/api'

export const AlbumCollectionTypeEnum = {
  Music: 1 as AlbumCollectionTypeEnumEnum,
  Podcast: 2 as AlbumCollectionTypeEnumEnum,
  AudioBook: 3 as AlbumCollectionTypeEnumEnum,
  Sermon: 4 as AlbumCollectionTypeEnumEnum,
} as const

export type AlbumCollectionTypeEnum =
  (typeof AlbumCollectionTypeEnum)[keyof typeof AlbumCollectionTypeEnum]

export const albumCollectionTypeArray = Object.values(AlbumCollectionTypeEnum)

export const getAlbumCollectionTypeString = (type: AlbumCollectionTypeEnum) => {
  switch (type) {
    case AlbumCollectionTypeEnum.Music:
      return 'Музыка'
    case AlbumCollectionTypeEnum.Podcast:
      return 'Подкаст'
    case AlbumCollectionTypeEnum.AudioBook:
      return 'Аудиокнига'
    case AlbumCollectionTypeEnum.Sermon:
      return 'Проповедь'
    default:
      return 'Неизвестный тип'
  }
}
